import { render, staticRenderFns } from "./icon-configurator-energy-economy-4.svg?vue&type=template&id=23d4c963&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports